import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.sass']
})
export class QueryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
